/**
 * Classe para os fields do tipo intervalo de algo.
 * @author: Fábio Junior
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Range = (function () {

    function Range () {

        Monet.UI.Fields.TextField.apply (this, arguments);

        this.createBaseStructure();

        var baseElement = null;

        this.value = {
            ini: '',
            fin: ''
        };
        this.labelRange = {};
        this.createElement = function () {

            if(!baseElement){

                this.labelRange = document.createElement("label");
                this.inputIni = document.createElement('input');
                this.inputFin = document.createElement('input');

                var divStart = document.createElement("div"),
                    divEnd = document.createElement("div");

                this.inputIni.type = 'text';

                this.inputFin.type = 'text';
                divStart.setAttribute('class', 'divRange');

                divEnd.setAttribute('class', 'divRange');
                divEnd.style.marginLeft = '0px';
                this.labelRange.setAttribute("class", "label_range");

                if(this.maxSize){
                    this.inputIni.maxLength = this.maxSize;
                    this.inputFin.maxLength = this.maxSize;
                }

                this.setInputValue();

                divStart.appendChild(this.inputIni);
                divEnd.appendChild(this.inputFin);

                this.rootEl.appendChild (divStart);
                this.rootEl.appendChild (this.labelRange);
                this.rootEl.appendChild (divEnd);
            }

        };

        this.getValue = function () {

            if(this.inputIni && this.inputFin){
                this.value.ini = this.inputIni.value;
                this.value.fin = this.inputFin.value;
            }

            return {
                ini: this.value.ini,
                fin: this.value.fin
            };
        };

        this.setValue = function (values) {
            if(values){
                this.value.ini = values.ini;
                this.value.fin = values.fin;
                this.setInputValue();
            }
        };

        this.setLabelRange = function (value) {
            this.labelRange.insertAdjacentHTML('beforeend', value);
        };

        this.setInputValue = function () {
            if (this.inputIni && this.inputFin) {

                if (this.value.ini) {
                    this.inputIni.value = this.value.ini;
                } else {
                    this.inputIni.value = '';
                }

                if (this.value.fin) {
                    this.inputFin.value = this.value.fin;
                } else {
                    this.inputFin.value = '';
                }
            }
        };

        this.clear = function (){
            this.setValue({
                ini: '',
                fin: ''
            });
        };

        this.render = function () {

            this.createElement();
            return this.rootEl;

        };

    }

    return Range;

}());